import { toSafeString } from '@shared/utils';
import getPieveApiBaseUrl from '@/lib/getPieveApiBaseUrl.js';

// The URL the customer pastes into the system that will call the workflow. Assembled here rather than
// stored, so it always reflects the current slug and the environment the renderer is talking to.
const buildPieveWorkflowWebhookUrl = ({ companyId, pathSlug } = {}) => {
  const normalizedCompanyId = toSafeString(companyId);
  const normalizedPathSlug = toSafeString(pathSlug);

  if (!normalizedCompanyId || !normalizedPathSlug) {
    return '';
  }

  return `${getPieveApiBaseUrl()}/v1/hook/pieve/workflow/${encodeURIComponent(normalizedCompanyId)}/${encodeURIComponent(normalizedPathSlug)}`;
};

export default buildPieveWorkflowWebhookUrl;
